export const debounce = (fn, delay = 500) => {
    let timer = null;
    return function () {
        let arg = arguments;
        // 每次操作时，清除上次的定时器
        if (timer) {
            clearTimeout(timer)
            timer = null;
        }
        // 定义新的定时器，一段时间后进行操作
        timer = setTimeout(() => {
            fn.apply(this, arg);
        }, delay);
    }
}



export function getIntersection(...arrays) {
    const [first, ...rest] = arrays.map((array) => new Set(array));
    return [
        ...rest.reduce(
            (acc, set) => new Set([...acc].filter((value) => set.has(value))),
            first
        ),
    ];
}


// const arr1 = [1, 2, 3, 4];
// const arr2 = [4, 5, 6];

// console.log(hasCommonElement(arr1, arr2)); // 输出 true，因为 4 是共同的元素
export function hasCommonElement(arr1, arr2) {
    const set1 = new Set(arr1); // 将 arr1 转为 Set
    return arr2.some((item) => set1.has(item)); // 如果 arr2 中有任何元素在 set1 中存在，则返回 true
}


export function isAndroid() {
    const userAgent = navigator.userAgent;
    return /android/i.test(userAgent);
}

export function isIOS() {
    const userAgent = navigator.userAgent;
    return /iphone|ipod|ipad/i.test(userAgent);
}


//生成 100 到 500 之间的随机整数
export function getRandomInt() {
    const values = [200, 300, 400, 500];
    return values[Math.floor(Math.random() * values.length)];
}




export function isInChina() {
    const domain = window.location.hostname;
    // 中国站域名（勿长期 return false，否则全局都会走「境外」逻辑，地图语言等会错乱）
    // console.log('当前域名:', domain);
    return 'www.castrol-autofilm.com.cn' == domain || 'www.castrolautofilm.com.cn' == domain || 'castrolautofilm.com.cn' == domain
    // return true;
}

// 是否使用天地图
// export function isUseTDMap() {
//     return true;
// }



export function isDebug() {
    const domain = window.location.hostname;
    console.log('当前域名:', domain);
    return 'www.castrol-autofilm.com.cn' != domain 
    && 'www.castrol-autofilm.com' != domain  
    && 'www.castrolautofilm.com.cn' != domain 
    && 'www.castrolautofilm.com' != domain 
    && 'castrolautofilm.com.cn' != domain 
    && 'castrolautofilm.com' != domain 
    && 'castrol-autofilm.com.cn' != domain 
    && 'castrol-autofilm.com' != domain 
    // return false;
}



// 判断是否是空对象
export function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}



export function maskMiddle(str, keepStart = 2, keepEnd = 4, maskChar = "*") {
    if (str == null) return "";
    const s = String(str);
    if (s.length <= keepStart + keepEnd) return s; // 太短就不遮
    const maskedLen = s.length - keepStart - keepEnd;
    return s.slice(0, keepStart) + maskChar.repeat(maskedLen) + s.slice(-keepEnd);
}


// 展示的处理
export function maskKeepFirstTwo(str, maskChar = "*") {
    if (str == null) return "";
    const s = String(str);
    if (s.length <= 2) return s;
    return s.slice(0, 2) + maskChar.repeat(s.length - 2);
}

/**
 * 计算：从右往左数，第一个 "(" 在第几位（从 1 开始）
 * 例："GTQZ SDN BHD (分销商)" -> 5
 */
export function rightIndexOfFirstParen(str) {
    if (str == null) return -1;
    const s = String(str);

    const idx = s.lastIndexOf("(");
    if (idx === -1) return -1;

    // 从右往左第几位 = 字符串长度 - idx
    return s.length - idx;
}






